'use client';

import { isSilencedOidcRuntimeError } from './error-silencing';

export function initRuntimeErrorGuards() {
    if (typeof window === 'undefined') {
        return;
    }

    window.addEventListener('unhandledrejection', (event) => {
        if (isSilencedOidcRuntimeError(event.reason, window.location?.pathname)) {
            event.preventDefault();
        }
    });

    window.addEventListener('error', (event) => {
        if (isSilencedOidcRuntimeError(event.error ?? event.message, window.location?.pathname)) {
            event.preventDefault();
        }
    });

    const previousOnError = window.onerror;
    window.onerror = (message, source, lineno, colno, error) => {
        if (isSilencedOidcRuntimeError(error ?? message, window.location?.pathname)) {
            return true;
        }

        if (typeof previousOnError === 'function') {
            return previousOnError.call(window, message, source, lineno, colno, error);
        }

        return false;
    };

    const previousOnUnhandledRejection = window.onunhandledrejection;
    window.onunhandledrejection = (event) => {
        if (isSilencedOidcRuntimeError(event.reason, window.location?.pathname)) {
            event.preventDefault();
            return true;
        }

        if (typeof previousOnUnhandledRejection === 'function') {
            return previousOnUnhandledRejection.call(window, event);
        }

        return false;
    };
}
